/** Формат размера в метрах для UI (до 3 знаков, ru-RU). */
export function formatDimM(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(value)) return '';
  const normalized = Math.round(value * 1000) / 1000;
  return new Intl.NumberFormat('ru-RU', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 3,
  }).format(normalized);
}

function billingNote(requested: number, billing: number | null | undefined, label: string): string | null {
  if (billing == null || !Number.isFinite(billing)) return null;
  if (Math.abs(billing - requested) < 1e-6) return null;
  return `${label}: ${formatDimM(billing)} м`;
}

/** Строки размеров для корзины / заказа: замер клиента + при необходимости шаг прайса. */
export function formatOrderDimensionLines(args: {
  length_m?: number | null;
  width_m?: number | null;
  projection_m?: number | null;
  custom_params?: Record<string, unknown> | null;
}): string[] {
  const cp = args.custom_params ?? {};
  const lines: string[] = [];
  const billingLen = cp.v2_billing_length_m;
  const billingW = cp.v2_billing_width_m;
  const billingP = cp.v2_billing_projection_m;

  if (args.length_m != null && Number.isFinite(args.length_m)) {
    let line = `Длина: ${formatDimM(args.length_m)} м`;
    const note = billingNote(args.length_m, typeof billingLen === 'number' ? billingLen : null, 'прайс');
    if (note) line += ` (${note})`;
    lines.push(line);
  }
  if (args.width_m != null && Number.isFinite(args.width_m)) {
    let line = `Ширина: ${formatDimM(args.width_m)} м`;
    const note = billingNote(args.width_m, typeof billingW === 'number' ? billingW : null, 'прайс');
    if (note) line += ` (${note})`;
    lines.push(line);
  }
  if (args.projection_m != null && Number.isFinite(args.projection_m)) {
    let line = `Вылет: ${formatDimM(args.projection_m)} м`;
    const note = billingNote(args.projection_m, typeof billingP === 'number' ? billingP : null, 'прайс');
    if (note) line += ` (${note})`;
    lines.push(line);
  }
  const clientH = cp.client_height_m;
  if (typeof clientH === 'number' && Number.isFinite(clientH)) {
    lines.push(`Высота проёма: ${formatDimM(clientH)} м`);
  }
  return lines;
}
